import { Component, OnInit} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-startpage',
    templateUrl: './startpage.component.html',
    styleUrls: ['./startpage.component.scss']
})

export class StartpageComponent implements OnInit {

    constructor(
        private router: Router,
        private seoService: SeoService,
    ) { }

    ngOnInit() {
        this.seoService.set({
            title: 'Spieloguide – Spielhallen, Wettbüros & Automaten in deiner Nähe finden',
            description: 'Finde Spielhallen, Wettbüros und Automatenaufstellplätze in deiner Nähe – mit Adresse, Öffnungszeiten und Anfahrt auf Spieloguide.',
            path: '/'
        });
    }

    // Redirect to search?q=SEARCHTERM
    submitSearch(form: NgForm) {
        if (form.invalid) {
            return;
          }
        this.router.navigate(['suche'] , { queryParams: { q: form.value.searchterm}});  
    };
}
